/*
 * @Author: cn1994
 * @Date: 2021-06-01 10:05:50
 * @LastEditors: cn1994
 * @LastEditTime: 2025-04-15 13:34:27
 * @Description: 请求封装
 */

import axios from "axios";
import { useBaseStore } from "@/stores/base";
import { Message } from "element-ui";
import { useUserStore } from '@/stores/user'
import { slsTracker } from "@/utils/slsTracker";


// 创建axios实例
const service = axios.create({
  baseURL: "",
  timeout: 300000 // 请求超时时间
});
const dateString = new Date();
const timezoneRegex = /GMT([+-]\d{4})/; // 匹配 GMT+0630 格式的时区信息
const timezoneMatch = dateString.toString().match(timezoneRegex);
const timezone = timezoneMatch[0];

// request拦截器
service.interceptors.request.use(
  config => {
    const baseStore = useBaseStore();
    const userStore = useUserStore()

    //oss的转发接口
    if (config.url.indexOf("OSSDCP/") >= 0) {
      // 小程序的接口
      config.url = config.url.replace("OSSDCP/", "");
      config.baseURL = `${baseStore.apiDomain}`;
      config.headers = {
        timeZone:timezone,
        instId:userStore.instId,
        token: userStore.token,
        serverId: userStore.serverId,
        devicetype: 0,
        apptype: 10,
        deviceuniqueid: "d91ed0b9-290c-4700-ad1e-1d619d625e54",
        'content-type': 'application/json;charset=utf-8',
        ...config.headers,
      }

    } else if (config.url.indexOf("MSITES/") >= 0) {
      // 小程序的接口
      config.url = config.url.replace("MSITES/", "");
      config.baseURL = `${baseStore.baseUrl.MobileStationUrl}/index.php/dcp/api/`;
      if (config.method === "post") {
        config.headers = {
          dcpToken: userStore.token,
          'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
        }
      } else {
        config.headers = {
          dcpToken: userStore.token,
        }
      }

    } else if (config.url.includes('OSS/')) {
      config.url = config.url.replace('OSS', '')
      if (process.env.NODE_ENV === "development") {
        config.baseURL = `${baseStore.baseDomain}`;
      } else {
        config.baseURL = `${baseStore.baseDomain}`;
      }
      // config.baseURL = `${baseStore.baseDomain.OssBaseUrl}`;
      config.headers = {
        timeZone:timezone,
        token: userStore.token,
        devicetype: 'oss',
        serverId: userStore.serverId,
        instId: userStore.instId,
        ...config.headers,
      }
    } else if (config.url.includes('QW/')) {
      config.url = config.url.replace('QW', '')
      config.baseURL = `${baseStore.qwDomain}`;
      config.headers = {
        token: userStore.token,
        devicetype: 'oss',
        serverId: userStore.serverId,
        instId: userStore.instId,
        ...config.headers,
      }
    } else if (config.url.includes('XTN')) {
      config.url = config.url.replace('XTN', '')
      if (location.href.includes('buwebgc.') || location.href.includes('wxbgc.')) {
        config.baseURL = 'https://xt-v8gc.51tyty.com/'
      } else if (location.host.includes('stage2ossm')) {
        config.baseURL = 'https://vs2php-v8.51tyty.com/'
        // config.baseURL = 'https://vs2php.51tyty.com/'
      } else if(location.host.includes('preossm')) {
        // xs环境习题baseURL
        config.baseURL = 'https://xsphp.51tyty.com/'
      } else if(location.host.includes('192.168.') || location.host.includes('localhost')){
        config.baseURL = 'https://vs2php-v8.51tyty.com/'
        // config.baseURL = 'https://xt-v8gc.51tyty.com/'
        // config.baseURL = 'http://xt8.51tyty.com/'
      } else {
        config.baseURL = 'https://xt-v8.51tyty.com/'
      }
      config.headers = {
        'Xx-Token': userStore.token,
        ...config.headers,
      }
    } else if (config.url.includes('XT')) {
      config.url = config.url.replace('XT', '')
      if (location.href.includes('buwebgc.') || location.href.includes('wxbgc.')) {
        config.baseURL = 'https://xt1.51tyty.com'
      } else if (location.host.includes('stage2ossm')) {
        config.baseURL = 'https://vs2php.51tyty.com/'
      } else if(location.href.includes('192.168.1.161')){
        // config.baseURL = 'https://vs2php.51tyty.com/'
        config.baseURL = 'https://vs2php-v8.51tyty.com/'
        // config.baseURL = 'http://xt8.51tyty.com/'
      } else {
        config.baseURL = baseStore.baseUrl.XtBaseUrl
      }
      config.headers = {
        'Xx-Token': userStore.token,
        ...config.headers,
      }
    } else if (config.url.includes('UGC/')) {
      config.url = config.url.replace('UGC', '')
      config.baseURL = userStore.newUgcUrl //取仓库里对应环境的对应ugc的数据
      config.headers = {
        token: userStore.token,
        devicetype: 'oss',
        serverId: userStore.serverId,
        instId: userStore.instId,
        ...config.headers,
      }
    } else if (config.url.includes('BUSINESS/')) {
      config.url = config.url.replace('BUSINESS', '')
       // if(location.href.includes('192.168.0.99:8080')){
       //    config.baseURL = 'http://127.0.0.1:8000'
       //  } else {
       //   config.baseURL = baseStore.businessDomain;
       //
       // }
      config.baseURL = baseStore.businessDomain;
      // config.baseURL = 'http://127.0.0.1:8000';
      config.headers = {
        timeZone:timezone,
        token: userStore.token,
        devicetype: 'oss',
        serverId: userStore.serverId,
        instId: userStore.instId,
        ...config.headers,
      }
    } else if (config.url.indexOf("BUSINESSDCP/") >= 0) {
      // 小程序的接口
      config.url = config.url.replace("BUSINESSDCP", "");
      config.baseURL = `${baseStore.businessDomain}/api.php`;
      config.headers = {
        timeZone:timezone,
        token: userStore.token,
        instId: userStore.instId,
        serverId: userStore.serverId,
        devicetype: 5,
        apptype: 10,
        deviceuniqueid: "d91ed0b9-290c-4700-ad1e-1d619d625e54",
        'content-type': 'application/json;charset=utf-8',
        ...config.headers,
      }

    }
    Object.keys(config.headers).forEach(key => {
      if (config.headers[key] == null) {
        delete (config.headers[key])
      }
    })
    return config;
  },
  error => {
    // Do something with request error
    Promise.reject(error);
  }
);

// respone拦截器
service.interceptors.response.use(
  response => {
    if (response.data.code == 401.1) {
      Message.error('登录过期，请重新登录!');
      window.location.href = '#/login'
    } else if (response.data.code != 0) {
      slsTracker.send({
        errorType: "api_failed",
        message: response
      })
      return response.data;
    }
    return response.data;
  },
  error => {
    slsTracker.send({
      errorType: "api_error",
      message: error
    })
    Promise.reject(error);
  }
);

export default service;
